<template>
    <div class="furtherWayReport">
        <div class="circle_box">
            <div class="canvas_box">
                <canvas id="canvas1" width="200" height="200"></canvas>
                <div class="box">
                    <p class='title title1'>符合的升学途径</p>
                    <p class='num num1'><span>{{reportData.conformNum}}/</span>{{reportData.totalNum}}</p>
                </div>
            </div>
            <div class="canvas_box">
                <canvas id="canvas2" width="200" height="200"></canvas>
                <div class="box">
                    <p class='title title2'>推荐的升学途径</p>
                    <p class='num num2'><span>{{reportData.recommendNum}}/</span>{{reportData.conformNum}}</p>
                </div>
            </div>
        </div>
        <div>
            <div class="main" v-if="reportData.recommend.length">
                <CircleName name='推荐的升学途径' style="margin-bottom: 15px"/>
                <div class="wayTitleBox">
                    <p v-for="(value,index) in reportData.recommend"
                       :class="recommendIndex == index?'active':''"
                       @click="changeWay(index,'recommendIndex')"
                       :key='index'
                    >
                        {{value.title}}
                    </p>
                </div>

                <div class="way">
                    <div class="box">
                        <p class="title">{{reportData.recommend[recommendIndex].title}}</p>
                        <p class="detail">{{reportData.recommend[recommendIndex].introduction}}</p>
                    </div>
                    <div class="box">
                        <p class="title">报考条件</p>
                        <div>
                            <p class="detindexail"  v-for="(value,index) in reportData.recommend[recommendIndex].condition" :key="index">{{value}}</p>
                        </div>
                    </div>
                    <div class="box">
                        <p class="title">推荐原因</p>
                        <p>
                            {{reportData.recommend[recommendIndex].recommendReason}}
                            <span v-for="(value,index) in reportData.recommend[recommendIndex].conditionOption"  :key="index">{{value}}</span>
                        </p>
                    </div>
                    <div class="beikao">
                        <p class="title">备考须知</p>
                        <p v-for="(value,index) in reportData.recommend[recommendIndex].notice" :key="index">{{value}}</p>
                    </div>
                </div>
                
            </div>


            <div class="main" v-if="reportData.unRecommend.length">
                <CircleName name='不推荐的升学途径' style="margin-bottom: 15px;"/>
                <div class="wayTitleBox">
                    <p
                        v-for="(value,index) in reportData.unRecommend"
                        :class="unRecommendIndex == index?'active':''"
                        @click="changeWay(index,'unRecommendIndex')"
                        :key='index'
                    >
                        {{value.title}}
                    </p>

                </div>

                <div class="way">
                    <div class="box">
                        <p class="title">{{reportData.unRecommend[unRecommendIndex].title}}</p>
                        <p class="detail">{{reportData.unRecommend[unRecommendIndex].introduction}}</p>
                    </div>
                    <div class="box">
                        <p class="title">报考条件</p>
                        <div>
                            <p class="detindexail"  v-for="(value,index) in reportData.unRecommend[unRecommendIndex].condition" :key="index">{{value}}</p>
                        </div>
                    </div>
                    <div class="box">
                        <p class="title">不推荐原因</p>
                        <p>
                            {{reportData.unRecommend[unRecommendIndex].noRecommendReason}}
                            <span v-for="(value,index) in reportData.unRecommend[unRecommendIndex].conditionOption"  :key="index">{{value}}</span>
                        </p>
                    </div>
                    <div class="beikao">
                        <p class="title">备考须知</p>
                        <p v-for="(value,index) in reportData.unRecommend[unRecommendIndex].notice" :key="index">{{value}}</p>
                    </div>
                </div>
            </div>
            <div class="main" v-if="reportData.incompatible.length">
                <CircleName name='不符合的升学途径'  style="margin-bottom: 15px;"/>
                <div class="wayTitleBox">
                    <p
                        v-for="(value,index) in reportData.incompatible"
                        :class="incompatibleIndex == index?'active':''"
                        @click="changeWay(index,'incompatibleIndex')"
                        :key='index'
                    >
                        {{value.title}}
                    </p>

                </div>
                <div class="way">
                    <div class="box">
                        <p class="title">{{reportData.incompatible[incompatibleIndex].title}}</p>
                        <p class="detail">{{reportData.incompatible[incompatibleIndex].introduction}}</p>
                    </div>
                    <div class="box">
                        <p class="title">报考条件</p>
                        <div>
                            <p class="detindexail"  v-for="(value,index) in reportData.incompatible[incompatibleIndex].condition" :key="index">{{value}}</p>
                        </div>
                    </div>
                    <div class="box">
                        <p class="title">不符合原因</p>
                        <p>
                            {{reportData.incompatible[incompatibleIndex].incompatibleReason}}
                            <span v-for="(value,index) in reportData.incompatible[incompatibleIndex].conditionOption"  :key="index">{{value}}</span>
                        </p>
                    </div>
                    <div class="beikao">
                        <p class="title">备考须知</p>
                        <p v-for="(value,index) in reportData.incompatible[incompatibleIndex].notice" :key="index">{{value}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CircleName from '@/components/consultant/CircleName.vue';
export default {
    props: ['reportData'],
    name: "furtherWayReport",
    components: {CircleName},
    data() {
        return {
            isShowPop: true,
            recommendIndex: 0,
            unRecommendIndex: 0,
            incompatibleIndex: 0,

        }
    },
    computed: {
      score1() {
          return this.reportData.conformNum/this.reportData.totalNum;
      },
      score2() {
        return this.reportData.recommendNum/this.reportData.conformNum;
      }
    },
    watch: {
    },
    methods: {
        changeWay(index,type) {
            this[type] = index;
        },
        setCanvas(score,id,color1,color2) {
            let ctx = document.getElementById(id).getContext('2d');
            // 底圈圆
            ctx.beginPath(); //起始路径，重置当前路径
            ctx.strokeStyle = color1; //设置或返回用于笔触的颜色、渐变或模式。
            ctx.lineWidth = 20;  //设置或返回当前的线条宽度。
            ctx.lineCap = 'round'; //设置或返回线条的结束端点样式。

            ctx.arc(100,100,90, 0 * Math.PI, 2*Math.PI); //4个刻度平分180°
            ctx.stroke()
            ctx.closePath()


            //动态圈
            ctx.beginPath(); //起始路径，重置当前路径

            ctx.strokeStyle = color2; //设置或返回用于笔触的颜色、渐变或模式。
            ctx.lineWidth = 20;  //设置或返回当前的线条宽度。
            ctx.lineCap = 'round'; //设置或返回线条的结束端点样式。

            ctx.arc(100,100,90, 1.5 * Math.PI,(score*2+1.5)*Math.PI); //4个刻度平分180°
            ctx.stroke()
            ctx.closePath()
        },

    },
    created() {
    },
    mounted() {
        this.setCanvas(this.score1,'canvas1','#0685CF','#AFDDF8');
        this.setCanvas(this.score2,'canvas2','#EA9347','#FDCEA9');
    }
}
</script>

<style scoped lang="less">
.furtherWayReport {
    .circle_box {
        display: flex;
        padding-bottom: 30px;
        .canvas_box {
            margin-right: 40px;
            position: relative;
            .box {
                position: absolute;
                width: 100%;
                top: 50%;
                margin-top: -45px;
                text-align: center;
                .title {
                    line-height: 30px;
                }
                .title1,.num1 {
                    color: #0685CF;
                }
                .title2,.num2 {
                    color: #EA9347;
                }
                .num {
                    line-height: 60px;
                    font-size: 27px;
                    font-weight: bold;
                    span {
                        font-weight: normal;
                    }
                }
            }
        }
    }
    .wayTitleBox {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        p {
            line-height: 38px;
            padding: 0 20px;
            background: #F6F6F6;
            margin-right: 10px;
            margin-bottom: 10px;
            cursor: pointer;
        }
        .active {
            background: rgba(61, 144, 246, 0.2);;
            color: #29A5ED;
        }
    }
    .way {
        padding: 20px;
        background: rgba(61, 144, 246, 0.2);
        margin-bottom: 50px;
        .box {
            margin-bottom: 20px;
            .title {
                font-size: 16px;
                line-height: 22px;
                margin-bottom: 5px;
                font-weight: bold;
            }
            .detail {
                font-size: 14px;
                line-height: 20px;
            }
        }
        .beikao {
            p {
                font-size: 14px;
                line-height: 30px;
            }
            .title {
                font-size: 16px;
                line-height: 40px;
                margin-bottom: 5px;
                font-weight: bold;
                color:#009BEF;
            }
        }
    }
}
</style>